import { ExportAttribution } from "../../types";

/**
 * see https://github.com/mapbox/mapbox-gl-js/blob/main/src/ui/control/attribution_control.js#LL157C1-L212C1
 * @param map
 * @returns HTML attribution string list
 */
export const getCurrentAttributions = (): ExportAttribution[] => {
  let attributions: Array<string> = []

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // const sources = map.getStyle().sources;

  // remove any entries that are substrings of another entry.
  // first sort by length so that substrings come first
  attributions.sort((a, b) => a.length - b.length)
  attributions = attributions
    .filter((attrib, i) => {
      for (let j = i + 1; j < attributions.length; j++) {
        if (attributions[j].indexOf(attrib) >= 0) { return false; }
      }
      return true;
    })
    .map((attrib) => attrib.split('|'))
    .flat()
    .map((attrib) => attrib.trim());

  const attributionItems: {
    html: string
    text: string
    links: { href: string; text: string }[]
  }[] = []

  // attribution は HTML なので、構造化する
  for (const attrib of attributions) {
    const html = attrib
    const div = document.createElement('div')
    div.innerHTML = html
    const text = div.textContent || ''
    const links = Array.from(div.querySelectorAll('a')).map((a) => ({
      href: a.href,
      text: a.textContent || '',
    }))
    attributionItems.push({ html, text, links })
  }

  return attributionItems
}
